import type { ColumnVisibilityState } from '@tanstack/react-table';

/**
 * Combine stored column preferences with a table's defaults.
 *
 * Reading storage on its own is wrong in a way that only shows up later: stored preferences
 * predate any column added after they were written, and TanStack treats a column absent from
 * the visibility state as VISIBLE. So a returning user gets every newly added column switched
 * on, whatever its default says, while a new user gets the default. Layering storage over the
 * defaults gives an unseen column its default and still lets an explicit choice win.
 */
export function mergeColumnVisibility(
    defaults: ColumnVisibilityState,
    stored: ColumnVisibilityState
): ColumnVisibilityState {
    return { ...defaults, ...stored };
}
